import { render, staticRenderFns } from "./StudentFacultyStatistics.vue?vue&type=template&id=0de8a926&scoped=true"
import script from "./StudentFacultyStatistics.vue?vue&type=script&lang=js"
export * from "./StudentFacultyStatistics.vue?vue&type=script&lang=js"
import style0 from "./StudentFacultyStatistics.vue?vue&type=style&index=0&id=0de8a926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de8a926",
  null
  
)

export default component.exports